import ProductQuery from './ProductQuery';

export default ProductQuery;
